// Supervisor Components Index - DÍA 5 Sub-paso 5.3.1
// Sistema de componentes especializados para supervisores de campo

import type { App } from 'vue'

// Importaciones de componentes de supervisor
import AgenciesManagementPanel from './AgenciesManagementPanel.vue'
import RouteProgressTracker from './RouteProgressTracker.vue'
import EmployeesManagementTable from './EmployeesManagementTable.vue'
import CreateRouteDialog from './CreateRouteDialog.vue'

// Componentes principales exportados
export { default as AgenciesManagementPanel } from './AgenciesManagementPanel.vue'
export { default as RouteProgressTracker } from './RouteProgressTracker.vue'
export { default as EmployeesManagementTable } from './EmployeesManagementTable.vue'
export { default as CreateRouteDialog } from './CreateRouteDialog.vue'

// Plugin para registro en Vue
export default {
  install(app: App) {
    // Registrar todos los componentes de supervisor
    app.component('AgenciesManagementPanel', AgenciesManagementPanel)
    app.component('RouteProgressTracker', RouteProgressTracker)
    app.component('EmployeesManagementTable', EmployeesManagementTable)
    app.component('CreateRouteDialog', CreateRouteDialog)
    
    console.log('✅ Componentes de Supervisor registrados')
  }
}

// Tipos y interfaces para supervisor
export interface SupervisorRoute {
  id: number
  name: string
  description?: string
  type: 'inspection' | 'maintenance' | 'collection' | 'supervision' | 'emergency'
  agencies: SupervisorAgency[]
  progress: number
  currentStop?: number
  startTime: string
  estimatedDuration: number
  estimatedTime?: string
  completedVisits?: number
  totalVisits?: number
  status: 'planned' | 'active' | 'paused' | 'completed' | 'cancelled'
}

export interface SupervisorAgency {
  id: number
  name: string
  address: string
  status: 'operational' | 'maintenance' | 'closed' | 'pending'
  lastVisit?: string
  issues?: number
  revenue?: number
  manager?: string
  priority?: 'low' | 'medium' | 'high' | 'critical'
}

export interface SupervisorEmployee {
  id: number
  name: string
  position: string
  schedule: string
  status: 'active' | 'inactive' | 'vacation'
  agency?: string
  performance?: number
  permissions?: string[]
  contact?: {
    phone?: string
    email?: string
  }
}

export interface SupervisorIncident {
  id: number
  description: string
  agency: string
  priority: 'low' | 'medium' | 'high' | 'critical'
  status: 'open' | 'in_progress' | 'resolved' | 'escalated'
  date: string
  assignedTo?: string
  reportedBy?: string
  category?: string
  estimatedCost?: number
}

export interface RouteOptimization {
  criteria: 'time' | 'distance' | 'priority' | 'traffic'
  avoidTraffic: boolean
  considerPriority: boolean
  maxVisitTime: number
  workingHours?: {
    start: string
    end: string
  }
}

export interface DepartmentReport {
  id: number
  type: 'daily' | 'incidents' | 'staff' | 'agencies' | 'inventory'
  department: string
  description: string
  data: any
  createdBy: string
  date: string
  status: 'draft' | 'sent' | 'reviewed' | 'approved'
}

export interface SupervisorPermissions {
  canEditAgencies: boolean
  canCreateRoutes: boolean
  canManageEmployees: boolean
  canEscalateIncidents: boolean
  canCreateReports: boolean
  canAccessInventory: boolean
  canViewAnalytics: boolean
}

export interface SupervisorConfig {
  groupId: number
  maxRoutesPerDay: number
  autoOptimizeRoutes: boolean
  notificationPreferences: {
    incidents: boolean
    routeUpdates: boolean
    employeeAlerts: boolean
  }
  workingHours: {
    start: string
    end: string
  }
}
